import { useCompleteStage } from '../hooks'
import type { NextStageRef } from '../types'

type Props = {
  contractId: number
  nextStage: NextStageRef | null
  disabled?: boolean
  gateClosed?: boolean
}

/**
 * Wyślij umowę dalej -- backendowy {@code StageSequencer} ustawia kolejny etap po
 * {@code sort_order}. Gate closed lub etap terminalny blokują przycisk; w pierwszym
 * przypadku tooltip informuje o niespełnionych warunkach.
 */
export function CompleteStageButton({ contractId, nextStage, disabled, gateClosed }: Props) {
  const mutation = useCompleteStage(contractId)
  if (!nextStage) return null
  const isDisabled = disabled || mutation.isPending
  return (
    <button
      type="button"
      disabled={isDisabled}
      onClick={() => mutation.mutate()}
      className="w-full rounded bg-sky-600 text-white px-2 py-1.5 text-xs disabled:opacity-50"
      title={gateClosed ? 'Niespełnione wymagania przejścia' : undefined}
    >
      Wyślij dalej do: {nextStage.labelPl}
    </button>
  )
}
